import { Helmet } from "react-helmet";
import BottomNavigationComponent from "../components/navigation/bottomNavigationComponent";
import PastToursLayout from "../sections/savedCalculations/pastToursLayout";

const navOption = 0;

const PastToursPage = () => {
    <Helmet>
        <title>Past Tours</title>
    </Helmet>

    return(
        <>
            <PastToursLayout navOption={navOption}/>

            <BottomNavigationComponent defaultIndex={navOption}/>
        </>
    );
}

export default PastToursPage;